import React, { useState, useEffect } from "react";
import { Navbar, Container, Nav, Button } from "react-bootstrap";
import { Link } from "react-scroll";
import askLmsLogo from "../../../assets/images/login/logo.png"
import { useNavigate } from "react-router-dom";
function NavBarComponents() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
const navigate=useNavigate()
  return (
    <Navbar
      expand="lg"
      variant="dark"
      fixed="top"
      className={scrolled ? "navbar-scrolled shadow-sm" : ""}
    >
      <Container>
        <Navbar.Brand
          // as={Link}
          // to="home"
          onClick={() => navigate('/')}
          className="d-flex align-items-center custom-font"
        >
          {/* <svg width="30" height="30" viewBox="0 0 100 100" className="me-2">
            <circle cx="50" cy="50" r="40" fill="#007bff" />
            <path
              d="M35 40L50 60L65 40"
              stroke="white"
              strokeWidth="8"
              fill="none"
            />
          </svg>
          <span className="fw-bold">AskLMS</span> */}

          <img src={askLmsLogo} alt="logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarNav" />
        <Navbar.Collapse id="navbarNav">
          <Nav className="ms-auto">
            <Nav.Link
              as={Link}
              to="home"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              Home
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="models"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              AI Models
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="features"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              Features
            </Nav.Link>
            {/* <Nav.Link
              as={Link}
              to="testimonials"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              Testimonials
            </Nav.Link> */}
            {/* <Nav.Link
              as={Link}
              to="pricing"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              Pricing
            </Nav.Link> */}
            <Nav.Link
              as={Link}
              to="contact"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              Contact
            </Nav.Link>
            {/* <div className="ms-lg-3 mt-2 mt-lg-0 ">
              <Button
                variant="primary"
                className="rounded-pill px-4"
                as={Link}
                to="/login"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
              >
                Get Started
              </Button>
            </div> */}


            <div
      className="ms-lg-3 mt-2 mt-lg-0"
      onClick={() => navigate('/login')}
      style={{ cursor: 'pointer' }}
    >
      <Button
        variant="primary"
        className="rounded-pill px-4"
      >
        Get Started
      </Button>
    </div>


          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBarComponents;
